export const isImageOrVideo = (file) => {
    const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp', 'image/svg+xml'];
    const videoTypes = ['video/mp4', 'video/webm', 'video/ogg', 'video/avi', 'video/mkv', 'video/mov'];

    if (file && file.type) {
        if (imageTypes.includes(file.type)) {
            return 'image';
        } else if (videoTypes.includes(file.type)) {
            return 'video';
        } else {
            return 'unknown';
        }
    }

    return 'invalid';
}